module.exports = __webpack_public_path__ + "img/man.6faa6134.png";